<template>
  <ion-app>
    <OfflineIndicator />
    <CookieConsent />
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue'
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useSettingsStore } from '@/stores/settings'
import OfflineIndicator from '@/components/OfflineIndicator.vue'
import CookieConsent from '@/components/CookieConsent.vue'

const authStore = useAuthStore()
const settingsStore = useSettingsStore()

onMounted(() => {
  // Initialize authentication
  authStore.initialize()
  
  // Load settings
  settingsStore.loadSettings()
  settingsStore.initializeThemeListener()
})
</script>

<style>
/* Import Ionic CSS - these will be processed by Vite */
@import '@ionic/vue/css/core.css';
@import '@ionic/vue/css/normalize.css';
@import '@ionic/vue/css/structure.css';
@import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out if not being used */
@import '@ionic/vue/css/padding.css';
@import '@ionic/vue/css/float-elements.css';
@import '@ionic/vue/css/text-alignment.css';
@import '@ionic/vue/css/text-transformation.css';
@import '@ionic/vue/css/flex-utils.css';
@import '@ionic/vue/css/display.css';

/* Import our custom theme and styles */
@import './styles/theme.css';
@import './styles/main.css';
</style>